import { z } from 'zod';
import { requiredUuidString } from '../zod-helpers/index.js';
import { PRICE_RULE_CONSTRAINTS } from './constraints.js';
// `note` is written unconditionally by the resolver -- `''`, whitespace-only, and `null` all
// normalize to `null` here so "clear the note" and "never had one" are indistinguishable, matching
// how a caller would expect an empty textarea to behave. This is the opposite convention from the
// derivation columns on PriceRuleAmountInput (absent there means "leave alone" is never an
// option -- always NULL); here absent/empty/null are all just "no note," on purpose.
export const setPriceRuleNoteInputSchema = z.object({
    priceRuleId: requiredUuidString('Pricing rule is required.', 'Invalid pricing rule selection.'),
    note: z
        .string()
        .trim()
        .max(PRICE_RULE_CONSTRAINTS.note.maxLength, `${PRICE_RULE_CONSTRAINTS.note.label} must be ${String(PRICE_RULE_CONSTRAINTS.note.maxLength)} characters or fewer.`)
        .nullish()
        .transform((value) => (value ? value : null)),
});
//# sourceMappingURL=set-price-rule-note-input.js.map